import React, { useEffect, useMemo, useState } from "react";
import {
  ArrowLeft,
  BookOpen,
  CheckCircle2,
  GraduationCap,
  MapPin,
  PlayCircle,
  Send,
  Trash2,
} from "lucide-react";
import TopBar from "../../components/TopBar";

const COURSE_PRICE = "49,90";

const INTERNAL_VIDEOS = [
  {
    title: "Tutorial installazione Norma",
    youtubeId: "b2Eym_ftxP8",
  },
  {
    title: "Autoconfiguratore - cos'è e come utilizzarlo",
    duration: "Video disponibile",
    description: "Guida all'autoconfiguratore e al suo utilizzo.",
    youtubeId: "OF4terTTPYU",
  },
  {
    title: "Autoconfiguratore - Ragione sociale e unità operativa",
    youtubeId: "B80Mrsob94M",
  },
  {
    title: "Autoconfiguratore - Prodotti gestiti / processi di lavorazione",
    youtubeId: "YLLj_a17DMs",
  },
  {
    title: "Autoconfiguratore - Igiene e sanificazione / struttura e impianti",
    youtubeId: "jdJXcgGu1Ak",
  },
  {
    title: "Autoconfiguratore - Ruoli e ditte esterne / Manuale",
    youtubeId: "amDWJRWvGwA",
  },
  {
    title: "Pannello di controllo - Visuale completa",
    youtubeId: "L65dL0NYrzA",
  },
  {
    title: "Associazione sonde Cryo ai frigoriferi su Norma",
    youtubeId: "Q8rKVydsQ4M",
  },
  {
    title: "Assegnare attività e scadenze a un operatore",
    youtubeId: "f2S4mkocUDo",
  },
  {
    title: "Guida alla dashboard di Norma",
    youtubeId: "PW7n-1DNMeQ",
  },
  {
    title: "Come utilizzare Norma AI",
    youtubeId: "4ylcc5Ma8Pg",
  },
  {
    title: "Gestione non conformità nel ricevimento merci",
    youtubeId: "AMNqfBtGEfQ",
  },
  {
    title: "Sanificazione",
    youtubeId: "OYqnMcA1cnk",
  },
  {
    title: "Abbattimenti",
    youtubeId: "Ec4QH_EfheI",
  },
  {
    title: "Etichette",
    youtubeId: "s7ikTdas6tc",
  },
  {
    title: "Controllo temperatura frigoriferi e QR code",
    youtubeId: "m4fNXlCmodY",
  },
  {
    title: "Igiene personale",
    youtubeId: "HvsNtI30PH8",
  },
  {
    title: "Ricezione merci",
    youtubeId: "tQ9jvkx_iMg",
  },
  {
    title: "Registri temperature, abbattimenti e sanificazione",
    youtubeId: "fNHmSGMoJiA",
  },
  {
    title: "Certificati e attestati",
    youtubeId: "UrNbihPwXIM",
  },
  {
    title: "Registro abbattimenti",
    youtubeId: "svOmCWbBLoo",
  },
  {
    title: "Procedure",
    youtubeId: "6z6kb05k9V0",
  },
  {
    title: "Allegati di gestione",
    youtubeId: "7ZA5_EkofUQ",
  },
  {
    title: "Verifica oli frittura",
    youtubeId: "P_TShmCTv7w",
  },
  {
    title: "Archivio DDT",
    youtubeId: "BcYCyUbbCiE",
  },
  {
    title: "Manutenzioni",
    youtubeId: "E_R8T8gjRpw",
  },
  {
    title: "Monitoraggio infestanti",
    youtubeId: "T0VCraiHsEE",
  },
  {
    title: "Audit interni ed esterni / verbali organi di controllo",
    youtubeId: "afTGthYf8JI",
  },
];

const COURSE_CATALOG = {
  "Emilia-Romagna": [
    ["4 ore", "Corso di formazione per personale alimentare"],
    ["4 ore", "Corso di formazione per personale alimentare - Aggiornamento"],
    ["6 ore", "Corso di formazione per responsabile delle procedure alimentari"],
    ["6 ore", "Corso di formazione per responsabile delle procedure alimentari - Aggiornamento"],
  ],
  Campania: [
    ["4 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio 1"],
    ["8 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio 2"],
    ["6 ore", "Corso di formazione per addetto alimentarista finalizzato alla prevenzione del rischio derivante dalla manipolazione di alimenti"],
    ["12 ore", "Corso di formazione per responsabili delle procedure alimentari", "Percorso misto: e-learning con integrazione documentale per ore in aula."],
    ["4 ore", "Corso di formazione per addetto alimentarista finalizzato alla prevenzione del rischio derivante dalla manipolazione di alimenti - Aggiornamento"],
    ["4 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio 1 - Aggiornamento"],
    ["4 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio 2 - Aggiornamento"],
    ["6 ore", "Corso di formazione per responsabile delle procedure alimentari - Aggiornamento"],
  ],
  Calabria: [
    ["8 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio A"],
    ["16 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio A"],
    ["6 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio B"],
    ["4 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio A - Aggiornamento"],
    ["4 ore", "Corso di formazione per personale alimentare: operatori di categoria di rischio B - Aggiornamento"],
  ],
  "Friuli-Venezia Giulia": [
    ["4 ore", "Responsabili autocontrollo - Imprese della commercializzazione"],
    ["4 ore", "Operatori a basso rischio - addetti di imprese che non manipolano alimenti"],
    ["3 ore", "Personale alimentare: addetti di imprese che operano una manipolazione a rischio"],
    ["8 ore", "Responsabili autocontrollo - Imprese della somministrazione"],
    ["8 ore", "Responsabili autocontrollo - Produzione, trasformazione, somministrazione complessa"],
    ["4 ore", "Personale alimentare: manipolazione a rischio - Aggiornamento"],
    ["4 ore", "Operatori a basso rischio - Aggiornamento"],
    ["8 ore", "Responsabili autocontrollo - Somministrazione - Aggiornamento"],
    ["8 ore", "Responsabili autocontrollo - Produzione, trasformazione, somministrazione complessa - Aggiornamento"],
    ["4 ore", "Responsabili autocontrollo - Commercializzazione - Aggiornamento"],
  ],
  Basilicata: [
    ["6 ore", "Corso per addetto alimentarista finalizzato alla prevenzione del rischio da manipolazione di alimenti"],
    ["4 ore", "Corso per addetto alimentarista - Aggiornamento"],
  ],
  Lazio: [
    ["6 ore", "Corso di formazione per personale alimentarista"],
    ["20 ore", "Corso per responsabili delle procedure alimentari", "Percorso misto: 8 ore e-learning + 12 ore in presenza."],
    ["4 ore", "Corso di formazione per personale alimentarista - Aggiornamento"],
    ["8 ore", "Corso di formazione per responsabili procedure alimentari - Aggiornamento"],
  ],
  Liguria: [
    ["4 ore", "Personale alimentarista - Attivita semplici - Unita formativa A - Aggiornamento"],
    ["8 ore", "Responsabili piani di autocontrollo e personale alimentarista di attivita complesse - Aggiornamento"],
  ],
  Lombardia: [
    ["4 ore", "Corso di formazione per personale alimentare"],
    ["6 ore", "Corso di formazione per responsabile delle procedure alimentari"],
    ["4 ore", "Corso di formazione per personale alimentare - Aggiornamento"],
    ["6 ore", "Corso di formazione per responsabile procedure alimentari - Aggiornamento"],
  ],
  Marche: [
    ["10 ore", "Formazione per addetto alimentarista - Corso base"],
    ["4 ore", "Personale alimentarista addetto ad attivita semplici - Aggiornamento"],
    ["8 ore", "Titolari e responsabili delle procedure di autocontrollo"],
    ["4 ore", "Corso di avanzamento per prevenzione rischio da manipolazione alimenti - Corso base"],
    ["4 ore", "Corso di avanzamento per prevenzione rischio da manipolazione alimenti - Aggiornamento"],
    ["6 ore", "Titolari e responsabili delle procedure di autocontrollo"],
    ["6 ore", "Personale alimentarista addetto alla produzione e preparazione alimenti - Aggiornamento"],
  ],
  Piemonte: [
    ["6 ore", "Corso di formazione per personale alimentare"],
    ["8 ore", "Corso di formazione per responsabile delle procedure alimentari"],
    ["4 ore", "Corso di formazione per personale alimentare - Aggiornamento"],
    ["6 ore", "Corso di formazione per responsabile delle procedure alimentari - Aggiornamento"],
  ],
  Puglia: [
    ["4 ore", "Corso di formazione per personale alimentare"],
    ["4 ore", "Corso di formazione per responsabile delle procedure alimentari"],
    ["4 ore", "Corso di formazione per personale alimentare - Aggiornamento"],
    ["4 ore", "Corso di formazione per responsabile delle procedure alimentari - Aggiornamento"],
  ],
  Sardegna: [
    ["4 ore", "Corso di formazione per personale alimentare"],
    ["6 ore", "Corso di formazione per responsabile delle procedure alimentari"],
    ["4 ore", "Corso di formazione per personale alimentare - Aggiornamento"],
    ["6 ore", "Corso di formazione per responsabile delle procedure alimentari - Aggiornamento"],
  ],
  "Trentino Alto Adige - provincia di Trento": [
    ["4 ore", "Personale che non manipola alimenti"],
    ["8 ore", "Responsabili delle procedure alimentari e titolari"],
    ["8 ore", "Personale coinvolto in attivita di produzioni alimentari"],
    ["4 ore", "Personale che non manipola alimenti - Aggiornamento"],
    ["4 ore", "Personale coinvolto in attivita di produzioni alimentari - Aggiornamento"],
    ["6 ore", "Responsabili procedure alimentari e titolari - Aggiornamento"],
  ],
  "Trentino Alto Adige - provincia di Bolzano": [
    ["4 ore", "Personale addetto alla produzione e preparazione di alimenti non facilmente deperibili - Categoria B"],
    ["6 ore", "Personale addetto alla somministrazione di alimenti - Categoria B"],
    ["6 ore", "Personale addetto al trasporto e vendita di alimenti deperibili - Categoria B"],
    ["8 ore", "Personale addetto alla produzione di alimenti - Categoria A"],
    ["4 ore", "Personale addetto alla somministrazione di alimenti - Categoria B - Aggiornamento"],
    ["4 ore", "Personale addetto alla produzione e preparazione di alimenti non facilmente deperibili - Categoria B - Aggiornamento"],
    ["6 ore", "Personale addetto alla produzione di alimenti - Categoria A - Aggiornamento"],
  ],
  Umbria: [
    ["4 ore", "Operatore del settore alimentare - Addetto ad attivita semplice - Corso base"],
    ["12 ore", "Operatore del settore alimentare - Addetto ad attivita complessa con manipolazione alimentare", "Percorso misto: 8 ore e-learning + 4 ore in presenza."],
    ["4 ore", "Operatore del settore alimentare - Addetto ad attivita semplice - Aggiornamento"],
  ],
  Veneto: [
    ["4 ore", "Personale che non manipola alimenti - Gruppo 1"],
    ["4 ore", "Personale che manipola alimenti - Gruppo 2"],
    ["4 ore", "Personale che non manipola alimenti - Gruppo 1 - Aggiornamento"],
    ["4 ore", "Personale che manipola alimenti - Gruppo 2 - Aggiornamento"],
  ],
  "Valle d'Aosta": [
    ["8 ore", "HACCP primo livello Regione Val d'Aosta"],
    ["4 ore", "HACCP secondo livello Regione Val d'Aosta"],
    ["8 ore", "HACCP Regione Val d'Aosta - Aggiornamento"],
  ],
};

const PENDING_REGIONS = ["Abruzzo", "Molise", "Sicilia", "Toscana"];

function createCourse(region, row, index) {
  return {
    id: `${region}-${index}`,
    region,
    duration: row[0],
    title: row[1],
    note: row[2] || "",
    mode: "E-learning",
    price: COURSE_PRICE,
  };
}

export default function RichiediCorso() {
  const [view, setView] = useState("home");
  const [region, setRegion] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [academyData, setAcademyData] = useState({ azienda: null, dipendenti: [] });
  const [checkout, setCheckout] = useState(null);
  const [form, setForm] = useState({
    note: "",
  });

  useEffect(() => {
    fetch("/api/norma_academy_context.php", { credentials: "include" })
      .then(async (res) => {
        const data = await res.json().catch(() => null);
        if (!res.ok || !data?.ok) throw new Error(data?.error || "Dati aziendali non disponibili");
        setAcademyData({ azienda: data.azienda, dipendenti: data.dipendenti || [] });
      })
      .catch((error) => setStatus({ type: "error", message: error.message }));
  }, []);

  const regions = useMemo(
    () => [...Object.keys(COURSE_CATALOG), ...PENDING_REGIONS].sort((a, b) => a.localeCompare(b, "it")),
    []
  );

  const courses = useMemo(() => {
    if (!region || !COURSE_CATALOG[region]) return [];
    return COURSE_CATALOG[region].map((row, index) => createCourse(region, row, index));
  }, [region]);

  const academyPartner = {
    name: academyData.azienda?.academy_partner_nome || "Meta Sicurezza",
    logoUrl: academyData.azienda?.academy_partner_logo_url || "/img/meta-sicurezza.png",
    email: academyData.azienda?.academy_partner_email || "",
    phone: academyData.azienda?.academy_partner_phone || "",
    address: academyData.azienda?.academy_partner_address || "",
  };
  const isCustomAcademyPartner = Boolean(
    academyData.azienda?.academy_partner_nome?.trim()
    && academyData.azienda.academy_partner_nome.trim().toLocaleLowerCase("it") !== "meta sicurezza"
  );

  const enrollmentCount = selectedCourses.reduce((total, item) => total + item.employeeIds.length, 0);
  const toggleCourse = (course) => {
    setCheckout(null);
    setSelectedCourses((current) => current.some((item) => item.course.id === course.id)
      ? current.filter((item) => item.course.id !== course.id)
      : [...current, { course, employeeIds: [] }]);
  };
  const toggleEmployee = (courseId, employeeId) => {
    setCheckout(null);
    setSelectedCourses((current) => current.map((item) => item.course.id !== courseId ? item : ({
      ...item,
      employeeIds: item.employeeIds.includes(employeeId) ? item.employeeIds.filter((id) => id !== employeeId) : [...item.employeeIds, employeeId],
    })));
  };

  const setField = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedCourses.length || selectedCourses.some((item) => item.employeeIds.length === 0)) return;

    setSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      const res = await fetch("/api/norma_academy_checkout.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          note: form.note,
          region,
          assignments: selectedCourses.map((item) => ({ course: item.course, dipendenti_ids: item.employeeIds })),
        }),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok || !data?.ok) {
        throw new Error(data?.error || "Invio non riuscito");
      }
      setCheckout(data);
      setStatus({ type: "success", message: `Richiesta ${data.reference} preparata. Prosegui con il pagamento sicuro Stripe.` });
    } catch (error) {
      setStatus({
        type: "error",
        message: error?.message || "Non e stato possibile inviare la richiesta.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <TopBar />
      <main className="min-h-screen bg-slate-50">
        <div className="mx-auto max-w-6xl px-4 py-8">
          <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
            <div>
              <p className="text-sm font-semibold uppercase tracking-wide text-[#0f6b72]">Norma Academy</p>
              <h1 className="mt-1 text-3xl font-semibold text-slate-950">Formazione</h1>
              {view === "courses" && academyData.azienda ? <div className="mt-3 flex items-center gap-3">
                <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  In collaborazione con
                </span>
                {academyPartner.logoUrl ? <img src={academyPartner.logoUrl} alt={academyPartner.name} className="h-10 w-auto max-w-[160px] object-contain" /> : <strong className="text-sm text-slate-700">{academyPartner.name}</strong>}
              </div> : null}
            </div>
            {view !== "home" ? (
              <button
                type="button"
                onClick={() => {
                  setView("home");
                  setSelectedCourses([]);
                  setStatus({ type: "", message: "" });
                }}
                className="inline-flex h-10 items-center gap-2 rounded-lg border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 hover:bg-slate-100"
              >
                <ArrowLeft className="h-4 w-4" />
                Torna
              </button>
            ) : null}
          </div>

          {view === "home" ? (
            <section className="grid gap-4 md:grid-cols-2">
              <button
                type="button"
                onClick={() => setView("videos")}
                className="group rounded-lg border border-slate-200 bg-white p-6 text-left shadow-sm transition hover:border-[#0f6b72] hover:shadow-md"
              >
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-lg bg-[#e7f4f3] text-[#0f6b72]">
                  <PlayCircle className="h-7 w-7" />
                </div>
                <h2 className="text-xl font-semibold text-slate-950">Video formativi interni</h2>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  Accesso alla raccolta dei video registrati per l'utilizzo del portale e delle procedure operative.
                </p>
              </button>

              <button
                type="button"
                onClick={() => setView("courses")}
                className="group rounded-lg border border-slate-200 bg-white p-6 text-left shadow-sm transition hover:border-[#0f6b72] hover:shadow-md"
              >
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-lg bg-[#eef2ff] text-[#314a8f]">
                  <GraduationCap className="h-7 w-7" />
                </div>
                <h2 className="text-xl font-semibold text-slate-950">Richiedi corsi di formazione</h2>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  Seleziona uno o più corsi, associali ai dipendenti e prepara un unico acquisto.
                </p>
              </button>
            </section>
          ) : null}

          {view === "videos" ? (
            <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
              <div className="mb-5 flex items-center gap-3">
                <PlayCircle className="h-6 w-6 text-[#0f6b72]" />
                <h2 className="text-xl font-semibold text-slate-950">Video formativi interni</h2>
              </div>
              <div className="grid gap-3 md:grid-cols-3">
                {INTERNAL_VIDEOS.map((video) => (
                  <div key={video.title} className="rounded-lg border border-slate-200 p-4">
                    {video.youtubeId ? (
                      <iframe
                        className="mb-3 aspect-video w-full rounded-md bg-slate-100"
                        src={`https://www.youtube-nocookie.com/embed/${video.youtubeId}`}
                        title={video.title}
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      />
                    ) : (
                      <div className="mb-3 flex aspect-video items-center justify-center rounded-md bg-slate-100 text-slate-400">
                        <PlayCircle className="h-10 w-10" />
                      </div>
                    )}
                    <h3 className="font-semibold text-slate-950">{video.title}</h3>
                    <p className="mt-1 text-xs font-semibold uppercase text-slate-500">
                      {video.duration || "Video disponibile"}
                    </p>
                    {video.description ? (
                      <p className="mt-2 text-sm leading-5 text-slate-600">{video.description}</p>
                    ) : null}
                  </div>
                ))}
              </div>
            </section>
          ) : null}

          {view === "courses" && isCustomAcademyPartner ? (
            <section className="mx-auto max-w-2xl rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm sm:p-10">
              {academyPartner.logoUrl ? <img src={academyPartner.logoUrl} alt={academyPartner.name} className="mx-auto h-20 w-auto max-w-[260px] object-contain" /> : null}
              <p className="mt-5 text-xs font-semibold uppercase tracking-wide text-[#0f6b72]">Partner per la formazione</p>
              <h2 className="mt-2 text-2xl font-semibold text-slate-950">{academyPartner.name}</h2>
              <p className="mx-auto mt-3 max-w-lg text-sm leading-6 text-slate-600">Per informazioni e richieste sui corsi di formazione contatta direttamente il tuo rivenditore.</p>
              <div className="mt-6 space-y-3 text-base text-slate-700">
                {academyPartner.email ? <a className="block font-medium text-[#0f6b72] hover:underline" href={`mailto:${academyPartner.email}`}>{academyPartner.email}</a> : null}
                {academyPartner.phone ? <a className="block font-medium text-[#0f6b72] hover:underline" href={`tel:${academyPartner.phone}`}>{academyPartner.phone}</a> : null}
                {academyPartner.address ? <p>{academyPartner.address}</p> : null}
                {!academyPartner.email && !academyPartner.phone && !academyPartner.address ? <p className="text-sm text-slate-500">I recapiti del rivenditore non sono ancora disponibili.</p> : null}
              </div>
            </section>
          ) : null}

          {view === "courses" && !isCustomAcademyPartner ? (
            <section className="grid gap-5 lg:grid-cols-[320px_minmax(0,1fr)]">
              <aside className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-4 flex items-center gap-3">
                  <MapPin className="h-5 w-5 text-[#0f6b72]" />
                  <h2 className="font-semibold text-slate-950">Regione</h2>
                </div>
                <label className="text-sm font-medium text-slate-700" htmlFor="academy-region">
                  Seleziona la regione
                </label>
                <select
                  id="academy-region"
                  value={region}
                  onChange={(event) => {
                    setRegion(event.target.value);
                    setSelectedCourses([]);
                    setStatus({ type: "", message: "" });
                  }}
                  className="mt-2 h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm outline-none focus:border-[#0f6b72] focus:ring-2 focus:ring-[#0f6b72]/20"
                >
                  <option value="">Scegli regione</option>
                  {regions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </aside>

              <div className="space-y-5">
                <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
                  <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
                    <div>
                      <h2 className="text-xl font-semibold text-slate-950">Corsi disponibili</h2>
                      <p className="text-sm text-slate-600">{region || "Seleziona una regione per visualizzare il catalogo."}</p>
                    </div>
                    <div className="rounded-lg bg-[#e7f4f3] px-3 py-2 text-sm font-semibold text-[#0f6b72]">
                      Euro {COURSE_PRICE}
                    </div>
                  </div>

                  {region && PENDING_REGIONS.includes(region) ? (
                    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm leading-6 text-amber-900">
                      Catalogo regionale in aggiornamento. Contatta il rivenditore per verificare la disponibilità.
                    </div>
                  ) : null}

                  {!region ? null : (
                    <div className="grid gap-3">
                      {courses.map((course) => (
                        <button
                          type="button"
                          key={course.id}
                          onClick={() => toggleCourse(course)}
                          className={`rounded-lg border p-4 text-left transition ${
                            selectedCourses.some((item) => item.course.id === course.id)
                              ? "border-[#0f6b72] bg-[#f0fbfa] ring-2 ring-[#0f6b72]/15"
                              : "border-slate-200 bg-white hover:border-slate-300"
                          }`}
                        >
                          <div className="flex flex-wrap items-start justify-between gap-3">
                            <div>
                              <p className="text-xs font-semibold uppercase text-slate-500">{course.duration} - {course.mode}</p>
                              <h3 className="mt-1 font-semibold text-slate-950">{course.title}</h3>
                              {course.note ? <p className="mt-2 text-sm text-slate-600">{course.note}</p> : null}
                            </div>
                            {selectedCourses.some((item) => item.course.id === course.id) ? <CheckCircle2 className="h-5 w-5 text-[#0f6b72]" /> : null}
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {selectedCourses.length ? (
                  <form onSubmit={handleSubmit} className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
                    <div className="mb-5 flex items-center gap-3">
                      <BookOpen className="h-5 w-5 text-[#0f6b72]" />
                      <div>
                        <h2 className="text-xl font-semibold text-slate-950">Scheda richiesta</h2>
                        <p className="text-sm text-slate-600">Associa a ogni corso uno o più dipendenti. Lo stesso dipendente può partecipare a più corsi.</p>
                      </div>
                    </div>

                    <div className="grid gap-4 md:grid-cols-2">
                      <div className="rounded-lg bg-slate-50 p-3 text-sm text-slate-700">
                        <div className="font-semibold text-slate-950">Azienda richiedente</div>
                        <div className="mt-1">{academyData.azienda?.nome || "Caricamento..."}</div>
                        <div className="text-slate-500">{academyData.azienda?.referente_nome} {academyData.azienda?.referente_email ? `- ${academyData.azienda.referente_email}` : ""}</div>
                      </div>
                      <div className="rounded-lg bg-slate-50 p-3 text-sm text-slate-700">
                        <div className="font-semibold text-slate-950">Corsi selezionati</div>
                        <div className="mt-1">{selectedCourses.length}</div>
                        <div className="mt-1 text-slate-500">Euro {COURSE_PRICE} per partecipante e per corso</div>
                      </div>
                    </div>

                    <div className="mt-4 space-y-4">
                      {selectedCourses.map((item) => (
                        <fieldset key={item.course.id} className="rounded-lg border border-slate-200 p-4">
                          <div className="flex items-start justify-between gap-3">
                            <div><legend className="font-semibold text-slate-950">{item.course.title}</legend><p className="text-xs text-slate-500">{item.course.duration} · {item.course.mode}</p></div>
                            <button type="button" onClick={() => toggleCourse(item.course)} className="text-slate-400 hover:text-rose-600" aria-label={`Rimuovi ${item.course.title}`}><Trash2 className="h-4 w-4" /></button>
                          </div>
                          <div className="mt-3 grid gap-2 sm:grid-cols-2">
                            {academyData.dipendenti.map((employee) => (
                              <label key={employee.id} className="flex cursor-pointer items-start gap-2 rounded-md border border-slate-200 px-3 py-2 text-sm hover:bg-slate-50">
                                <input type="checkbox" checked={item.employeeIds.includes(Number(employee.id))} onChange={() => toggleEmployee(item.course.id, Number(employee.id))} className="mt-0.5 h-4 w-4" />
                                <span>{employee.cognome} {employee.nome}{employee.mansione ? <small className="block text-slate-500">{employee.mansione}</small> : null}</span>
                              </label>
                            ))}
                          </div>
                          <p className={`mt-2 text-xs ${item.employeeIds.length ? "text-slate-500" : "font-medium text-amber-700"}`}>{item.employeeIds.length ? `${item.employeeIds.length} partecipanti · Euro ${(item.employeeIds.length * 49.9).toFixed(2).replace(".", ",")}` : "Seleziona almeno un dipendente"}</p>
                        </fieldset>
                      ))}
                    </div>

                    <div className="mt-4 rounded-lg border border-slate-200 p-3 text-sm">
                      <div className="flex justify-between"><span>Iscrizioni complessive</span><strong>{enrollmentCount}</strong></div>
                      <div className="mt-1 flex justify-between"><span>Totale</span><strong>Euro {(enrollmentCount * 49.9).toFixed(2).replace(".", ",")}</strong></div>
                    </div>

                    <label className="mt-4 block text-sm font-medium text-slate-700">
                      Note
                      <textarea
                        value={form.note}
                        onChange={(event) => setField("note", event.target.value)}
                        rows={4}
                        className="mt-2 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#0f6b72] focus:ring-2 focus:ring-[#0f6b72]/20"
                      />
                    </label>

                    {status.message ? (
                      <div
                        className={`mt-4 rounded-lg p-3 text-sm ${
                          status.type === "success" ? "bg-emerald-50 text-emerald-800" : "bg-rose-50 text-rose-800"
                        }`}
                      >
                        {status.message}
                      </div>
                    ) : null}

                    <div className="mt-5 flex flex-wrap items-center gap-3">
                      <button
                        type="submit"
                        disabled={submitting || enrollmentCount === 0 || selectedCourses.some((item) => item.employeeIds.length === 0)}
                        className="inline-flex h-11 items-center gap-2 rounded-lg bg-[#043662] px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#032f56] disabled:cursor-not-allowed disabled:opacity-60"
                      >
                        <Send className="h-4 w-4" />
                        {submitting ? "Preparazione in corso" : "Prepara acquisto"}
                      </button>
                      {checkout?.purchase_url ? (
                        <a href={checkout.purchase_url} className="inline-flex h-11 items-center rounded-lg bg-emerald-600 px-5 text-sm font-semibold text-white" rel="noreferrer">
                          Paga con Stripe
                        </a>
                      ) : null}
                    </div>
                  </form>
                ) : null}
              </div>
            </section>
          ) : null}
        </div>
      </main>
    </>
  );
}
